import { Checkbox } from '@/components/ui/checkbox'
import { GridCellProps, GridColumnProps, GridFilterCellProps } from '@progress/kendo-react-grid'
import { Language } from 'api/Clients/Types/Language'
import {
  CheckboxFilterCell,
  InputFilterCell,
  LanguagesFilterCell,
} from 'components/Filter/FilterCell'
import { LanguagesFilterCellProps } from 'components/Filter/FilterCell/LanguagesFilterCell'

import { RoleTag } from '../Users/RoleTag'
import { CompaniesFilterCell, TickmillCompanyFilterCell } from './CountriesFilters'

const LanguagesNameFilterCell = (props: GridFilterCellProps & LanguagesFilterCellProps) => {
  return (
    <LanguagesFilterCell
      {...props}
      items={(items: Language[]) => items.map((x) => ({ id: x.id, value: x.name, label: x.name }))}
    />
  )
}

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

const countriesColumns: GridColumn[] = [
  {
    title: 'Country',
    field: 'country.name',
    filterCell: InputFilterCell,
    show: true,
    sortable: false,
  },
  {
    title: 'Preferred Tickmill Entity',
    field: 'preferredCompany.name',
    filterCell: TickmillCompanyFilterCell,
    cell: (props: GridCellProps): JSX.Element => {
      if (!props?.dataItem?.preferredCompany?.name) {
        return <td />
      }

      return <td>{props.dataItem.preferredCompany.name}</td>
    },
    show: true,
    sortable: false,
  },
  {
    title: 'Language',
    field: 'language.name',
    filterCell: (props) => (
      <LanguagesNameFilterCell
        {...props}
        items={(items: Language[]) =>
          items.map((x) => ({ id: x.id, value: x.name, label: x.name }))
        }
      />
    ),
    show: true,
    sortable: false,
  },
  {
    title: 'Entities',
    field: 'companies',
    filterCell: CompaniesFilterCell,
    cell: (props: GridCellProps): JSX.Element => {
      if (!props.dataItem.companies) {
        return <td />
      }

      return (
        <td>
          {props.dataItem.companies.map(
            (company: {
              company: { shortName: string; id: number; name: string }
              isPreffered: boolean
            }) => (
              <RoleTag
                key={company.company.id}
                role={company.company.name}
                index={company.company.id}
              />
            )
          )}
        </td>
      )
    },
    show: true,
    sortable: false,
  },
  {
    title: 'EAA',
    field: 'country.isEuropeanUnion',
    filterCell: CheckboxFilterCell,
    cell: (props: GridCellProps): JSX.Element => {
      return (
        <td align='center' style={{ textAlign: 'center' }}>
          <Checkbox checked={props.dataItem.country.isEuropeanUnion} disabled />
        </td>
      )
    },
    show: true,
    sortable: false,
  },
  {
    title: 'Default Public Domain',
    field: 'defaultPublicDomain',
    cell: (props: GridCellProps): JSX.Element => {
      if (!props?.dataItem?.defaultPublicDomain) {
        return <td />
      }
      return <td>{props?.dataItem?.defaultPublicDomain}</td>
    },
    show: true,
    sortable: false,
  },
  {
    title: 'Phone Code',
    field: 'phoneCode',
    filterCell: InputFilterCell,
    show: true,
    sortable: false,
  },
  {
    title: 'Phone Verification',
    field: 'phoneVerificationRequired',
    filterCell: CheckboxFilterCell,
    cell: (props: GridCellProps): JSX.Element => {
      return (
        <td align='center' style={{ textAlign: 'center' }}>
          <Checkbox checked={props.dataItem.phoneVerificationRequired} disabled />
        </td>
      )
    },
    show: true,
    sortable: false,
  },
  {
    title: 'Phone Verification Provider',
    field: 'country.name',
    filterCell: () => null,
    cell: (props: GridCellProps): JSX.Element => {
      if (props?.dataItem?.phoneVerificationProvider?.id === 1) {
        return <td />
      }

      return <td>{props.dataItem.phoneVerificationProvider.name}</td>
    },
    show: true,
    sortable: false,
  },
]

export default countriesColumns
